import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../Assets/efficientailogo.png";
import { motion, AnimatePresence } from "framer-motion";
import { HiMenu, HiX } from "react-icons/hi";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToFeatures = () => {
    closeMenu();
    const featuresSection = document.getElementById("features");
    if (featuresSection) {
      featuresSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <AnimatePresence>
      <>
        {/* Top Ribbon */}
        <div className="bg-yellow-700 px-10 py-2 text-white text-center">
          <div className="flex justify-center items-center">
            <p className="text-sm md:text-base">
              <span className="font-bold underline">DeepSeek R1</span> is now
              available on EfficientAI,
              <a
                className="underline"
                href="https://tally.so/r/nWeMbj"
                target="_blank"
                rel="noopener noreferrer"
              >
                Try it now!
              </a>
            </p>
          </div>
        </div>

        <header className="sticky top-0 z-50 pt-1 w-full bg-gray-50 ">
          <div className="flex justify-between items-center mx-auto w-[90%] lg:w-[80%] py-2 px-4 md:px-8 border-2 border-gray-400 rounded-full">
            <a href="/" className="flex items-center">
              <img src={logo} alt="EfficientAI Logo" className="w-9 h-auto" />
              <p className="ml-2 text-lg md:text-2xl font-semibold text-gray-900">
                Efficient<span className="text-yellow-600">AI</span>
              </p>
            </a>

            <div className="hidden md:flex items-center md:space-x-6 lg:space-x-12 text-lg">
              {["Home", "About", "Blogs"].map((label, index) => (
                <NavLink
                  key={index}
                  to={label === "Home" ? "/" : `/${label.toLowerCase()}`}
                  onClick={scrollToTop}
                  className={({ isActive }) =>
                    isActive
                      ? "text-yellow-600 font-semibold transition-colors"
                      : "text-gray-900 hover:text-yellow-600 font-semibold transition-colors"
                  }
                >
                  <p>{label}</p>
                </NavLink>
              ))}
              <p>
                <button
                  onClick={scrollToFeatures}
                  className="text-gray-900 hover:text-yellow-600 font-semibold transition-colors"
                >
                  Features
                </button>
              </p>
            </div>

            <div className="hidden md:block">
              <NavLink to="https://calendly.com/tejasnarayan" target="_blank">
                <button className="bg-white text-gray-900 border-2 border-gray-300 px-4 py-2 transition-all duration-150 rounded-md font-bold hover:bg-gray-100 hover:scale-105">
                  <p>Book a Demo</p>
                </button>
              </NavLink>
            </div>

            <div className="md:hidden flex items-center">
              <button
                onClick={toggleMenu}
                aria-label="Toggle menu"
                className="text-gray-900"
              >
                {menuOpen ? <HiX size={30} /> : <HiMenu size={30} />}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {menuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "100vh" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.5 }}
              className="fixed top-0 left-0 w-full h-full bg-white text-gray-900 flex flex-col items-center justify-start z-20 p-10"
            >
              <button
                onClick={closeMenu}
                aria-label="Close menu"
                className="absolute top-5 right-5 text-gray-900"
              >
                <HiX size={30} />
              </button>

              {["Home", "About", "Blogs"].map((label, index) => (
                <NavLink
                  key={index}
                  to={
                    label === "Home"
                      ? "/"
                      : `/${label.toLowerCase().replace(" ", "")}`
                  }
                  onClick={() => {
                    scrollToTop();
                    closeMenu();
                  }}
                  className={({ isActive }) =>
                    isActive
                      ? "text-yellow-600 font-semibold transition-colors px-4 py-5 text-lg"
                      : "text-gray-900 hover:text-yellow-600 font-semibold transition-colors px-4 py-5 text-lg"
                  }
                >
                  <p>{label}</p>
                </NavLink>
              ))}

              <p>
                <button
                  onClick={scrollToFeatures}
                  className="text-gray-900 text-lg my-4 hover:text-yellow-600 font-semibold transition-colors"
                >
                  Features
                </button>
              </p>

              <NavLink to="https://calendly.com/tejasnarayan" target="_blank">
                <button className="bg-white text-gray-900 border-2 border-gray-300 px-4 py-4 transition-all duration-150 rounded-md font-bold hover:bg-gray-100 hover:scale-105 mt-2">
                  <p>Book a Demo</p>
                </button>
              </NavLink>
            </motion.div>
          )}
        </header>
      </>
    </AnimatePresence>
  );
};

export default Header;
